






















































































import {
  apiOrderWriteOffPreWriteOffInfo,
  apiOrderWriteOffWriteOff,
  apiOrderWriteOffWriteOffDetail,
  ApiOrderWriteOffWriteOffDetailResponse,
} from '@/api'
import { BookComponents } from '../components'
import { computed, watch } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery, useSet } from '@/hooks'
import { redirectTo } from '@/router'
import { submit, Track } from '@/utils'
import { wait } from 'vtils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '确认核销',
        }))

        watch(
          () => this.pageData.value,
          () => {
            if (
              this.pageData.value?.code?.length === 1 &&
              !this.selectedCoupons.value.length
            ) {
              this.selectedCouponSet.add(this.pageData.value.code[0])
            }
          },
          { immediate: true },
        )
      }

      query = useQuery<{
        code: string
        orderNo: string
      }>()

      apiData = useApi(
        () =>
          this.query.code
            ? apiOrderWriteOffWriteOffDetail({
                code: this.query.code,
              }).then<ApiOrderWriteOffWriteOffDetailResponse>(
                res =>
                  ({
                    ...res,
                    code: res.code ? [res.code] : [],
                  } as any),
              )
            : apiOrderWriteOffPreWriteOffInfo({
                orderNo: this.query.orderNo,
              }).then<ApiOrderWriteOffWriteOffDetailResponse>(
                res =>
                  ({
                    ...res,
                    code: res.codeList,
                  } as any),
              ),
        {
          onError: () =>
            wait(1500).then(() => {
              redirectTo('BookVerifyResult', {
                success: false,
              })
            }),
        },
      )

      pageData = computed(() => this.apiData.data)

      selectedCouponSet = useSet<string>([])

      selectedCoupons = computed(this.selectedCouponSet.toArray)

      handleVerifyConfirmClick = () => {
        submit(async $ => {
          if (!this.selectedCoupons.value.length) {
            return $.fail('请选择要核销的券码')
          }
          $.start('核销中...')
          try {
            await apiOrderWriteOffWriteOff({
              code: this.selectedCoupons.value,
            })
            redirectTo('BookVerifyResult', {
              success: true,
            })
          } catch {
            redirectTo('BookVerifyResult', {
              success: false,
            })
          }
        })
      }
    },
)
